import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const r = l(
  (a, e) => /* @__PURE__ */ o.jsx(
    t,
    {
      ref: e,
      ...a,
      image: (i) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...i,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M14 4c0 .35-.06.687-.17 1H14a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.17A3 3 0 0 1 7.4 2.2L8 3l.6-.8A3 3 0 0 1 14 4M4 4a1 1 0 0 1 1.8-.6L7 5H5a1 1 0 0 1-1-1m7 1H9l1.2-1.6A1 1 0 1 1 11 5M4 8v2h8V8z",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
r.displayName = "GiftIcon";
export {
  r as GiftIcon,
  r as default
};
//# sourceMappingURL=index.js.map
